/* eslint-disable no-unused-vars */
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faChalkboardTeacher,
  faChalkboard,
  faMedal,
  faTrophy,
  faFileAlt,
  faUserFriends,
  faSun,
  faFlag,
  faRoute,
  faRankingStar,
  faShieldHalved,
  faCalendar,
  faList,
  faUser,
  faChartBar,
  faPlayCircle,
  faDumbbell,
  faWrench,
  faBirthdayCake,
  faBuilding,
  faCampground,
  faCoffee,
} from '@fortawesome/free-solid-svg-icons';

const ContenedorPrincipal = styled.div`
  margin-bottom: 50px;
`;

const TituloCabeza = styled.h3`
  font-family: 'GarnetLight';
  font-weight: bold;
  padding: 10px;
  margin-top: 40px;
  text-align: center;
  font-size: 26px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
  background: linear-gradient(
    to right,
    transparent 0%,
    transparent 10%,
    rgb(242, 242, 242) 45%,
    transparent 95%,
    transparent 100%
  );
`

const ContenedorApartado = styled.div`
  max-width: 1600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
`;

const Titulo = styled.h3`
  color: #000000;
  font-weight: 400;
  font-family: 'GarnetLight';
  margin-left: 4px;
  margin-right: 4px;
 font-size: 20px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
const Cards = styled.figure`
  background-color: ${(props) => props.color};
  position: relative;
  cursor: pointer;
  width: 100%;
  max-width: 325px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 6px;
  box-shadow: 0px 10px 10px rgb(173, 173, 173);
  background-color: #a0f000cf;
  transition: transform 0.3s ease;
  margin: 5px;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    max-width: 46%;
    max-height: 200px;
    margin: 5px;
  }
`

const ContenedorBoton = styled.img`
  margin: 0;
  width: 100%;
  height: 200px;
  will-change: transform;

  @media (max-width: 768px) {
    height: 110px;
  }
`
const Capa = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;


  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > svg {
    margin-bottom: 10px;
    color: black;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }
`

const LogoImage = styled.img`
  cursor: pointer;
  width: 70px;
  height: auto;
`;

const TituloYBoton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const BotonesContenedor = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 25px;
  gap: 0px 15px;
 @media (max-width: 768px) {
    flex-direction: row; /* Asegura que los botones estén en horizontal en pantallas pequeñas */
  }
`;

const BotonInscripcion = styled.button`
  font-family: 'GarnetLight';
  margin-top: 10px;
  width: 99%;
  background-color: #a0f000cf;
  color: #000000;
  border: transparent solid 0px;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  text-decoration: none;
  text-align: center;
  font-size: 13px;

  &:hover {
    transform: scale(1.05);
     
  }
`;

// const BotonCalendario = styled(BotonInscripcion)`
//   background-color: #da9bffcf;
// `;

const BotonCampus = styled(BotonInscripcion)`
  background-color: #3187ffcf;
`;

const Card = () => {
  return (
    <ContenedorPrincipal>

      {/* BOTONES PRINCIPALES TENIS */}
      <TituloYBoton>
        <TituloCabeza>ESCUELA DE TENIS</TituloCabeza>

        <BotonesContenedor>
  
          <BotonInscripcion as={Link} to="/clubs/montequinto/informacioneinscripcionmontequinto">
            Información e inscripción de la escuela 26 - 27
          </BotonInscripcion>

          {/* <BotonCalendario as={Link} to="/clubs/bellavista/calendariobellavista">
            Calendario 25 - 26
          </BotonCalendario> */}


        <BotonCampus as={Link} to="/clubs/montequinto/alquilerdepistas">
            ALQUILER DE PISTAS
          </BotonCampus>


        </BotonesContenedor>
      </TituloYBoton>

      {/* ESCUELA DE TENIS */}
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/escueladeformación">
            <ContenedorBoton />
            <Capa>
              <img src={`${process.env.PUBLIC_URL}/pista.png`} alt="Logo" width="70" />
              <Titulo>escuela de formación</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/escueladeadultos">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faUsers} size="2x" color="white" />
              <Titulo>escuela de adultos</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/clasesparticulares">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faChalkboardTeacher} size="2x" color="white" />
              <Titulo>clases particulares</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/planificaciondeentrenamiento">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faChalkboard} size="2x" color="white" />
              <Titulo>PLANIFICACIÓN de entrenamientos NSTA escuela de formación</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* ACADEMIA COMPETICIÓN */}
      <TituloCabeza>ACADEMIA COMPETICIÓN</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/academianstadecompeticion">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faMedal} size="2x" color="white" />
              <Titulo>academia nsta competición</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/planificaciondeentrenamientocompeticion">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faTrophy} size="2x" color="white" />
              <Titulo>PLANIFICACIÓN DE ENTRENAMIENTOS NSTA COMPETICIÓN</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/programanstatour">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faFileAlt} size="2x" color="white" />
              <Titulo>programa nsta tour (dosier)</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/serviciosdecoachatorneos">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faUserFriends} size="2x" color="white" />
              <Titulo>Servicios de coach a torneos</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* INTENSIVOS DE TENIS */}
      <TituloCabeza>INTENSIVOS DE TENIS</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/intensivosdeverano">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faSun} size="2x" color="white" />
              <Titulo>intensivo de verano</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* EVENTOS */}
      <TituloCabeza>EVENTOS</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/eventotenisbhc">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faFlag} size="2x" color="white" />
              <Titulo>eventos tenis M5</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/circuitointernobhc">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faRoute} size="2x" color="white" />
              <Titulo>Circuito interno M5</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/rankinginternobhc">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faRankingStar} size="2x" color="white" />
              <Titulo>Ranking interno M5</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/ligabhc">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faShieldHalved} size="2x" color="white" />
              <Titulo>Liga M5</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* OTROS SERVICIOS */}
      <TituloCabeza>OTROS SERVICIOS</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/calendariodecompeticion">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faCalendar} size="2x" color="white" />
              <Titulo>CALENDARIO DE COMPETICIÓN</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/planificaciondetodoslosniveles">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faList} size="2x" color="white" />
              <Titulo>PLANIFICACIÓN DE TODOS LOS NIVELES DE ESCUELA DE FORMACIÓN</Titulo>
            </Capa>
          </Link>
        </Cards>

 

        <Cards>
          <Link to="/clubs/montequinto/estadisticasyvideoanalisis">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faChartBar} size="2x" color="white" />
              <Titulo>ESTADÍSTICAS Y VÍDEO ANÁLISIS</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/videotutoriales">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faPlayCircle} size="2x" color="white" />
              <Titulo>VIDEO TUTORIALES NSTA</Titulo>
            </Capa>
          </Link>
        </Cards>

  
        <Cards>
          <Link to="/clubs/montequinto/serviciosdeencordados">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faWrench} size="2x" color="white" />
              <Titulo>SERVICIOS DE ENCORDADOS DE RAQUETAS</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/cumnpleañosdeportivos">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faBirthdayCake} size="2x" color="white" />
              <Titulo>CUMPLEAÑOS DEPORTIVOS</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/globalcollage">
            <ContenedorBoton />
            <Capa>
              <LogoImage src={`${process.env.PUBLIC_URL}/globalcollage.png`} alt="Global Collage Logo" />
              <Titulo>BECAS USA</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* + SERVICIOS CLUB */}
      <TituloCabeza>+ SERVICIOS CLUB</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/escueladeportivaveranom5">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faCampground} size="2x" color="white" />
              <Titulo>Escuela Deportiva De Verano</Titulo>
            </Capa>
          </Link>
        </Cards>

        <Cards>
          <Link to="/clubs/montequinto/kioskobar">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faCoffee} size="2x" color="white" />
              <Titulo>kiosko bar</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

      {/* INSTALACIONES */}
      <TituloCabeza>INSTALACIONES CLUB</TituloCabeza>
      <ContenedorApartado>
        <Cards>
          <Link to="/clubs/montequinto/instalaciones">
            <ContenedorBoton />
            <Capa>
              <FontAwesomeIcon icon={faBuilding} size="2x" color="white" />
              <Titulo>INSTALACIONES CLUB</Titulo>
            </Capa>
          </Link>
        </Cards>
      </ContenedorApartado>

    </ContenedorPrincipal>
  );
};

export default Card;